import {
    iconRequest,
    iconClient,
    iconReportsDefault,
    iconReports,
    iconCalculator,
    // iconCertificate,
    iconSearch,
    iconParameters,
    // iconDocs,
    iconParametersGyg,
    iconPolizas,
    iconWarranty,
    iconHandshake,
} from '../defaultValues';

const data = {
    role_66db027cb55a420a99a954fd356183c7: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        // {
        //     id: 'financialSolutions',
        //     icon: iconHandshake,
        //     label: 'Soluciones Financieras',
        //     to: '/app/financialSolutions/list',
        // },

        {
            id: 'financialSolutions',
            icon: iconHandshake,
            label: 'Soluciones Financieras',
            subs: [
                {
                    id: 'gestiona-soluciones-financieras',
                    icon: iconReportsDefault,
                    label: 'Gestionar',
                    to: '/app/financialSolutions/list',
                },
                {
                    id: 'consulta-soluciones-financieras',
                    icon: iconReportsDefault,
                    label: 'Consultar',
                    to: '/app/financialSolutionsConsults/list',
                },
                {
                    id: 'secondmenu',
                    icon: iconReportsDefault,
                    label: 'Registro masivo',
                    to: '/app/massiveFinanceSolution',
                },
            ],
        },

        {
            id: 'neww',
            icon: iconWarranty,
            label: 'Garantía Vehicular',
            subs: [
                {
                    id: 'gestiona-garantias',
                    icon: iconReportsDefault,
                    label: 'Gestionar',
                    to: '/app/warranty',
                },
                {
                    id: 'consulta-garantias',
                    icon: iconReportsDefault,
                    label: 'Consultar',
                    to: '/app/radicationWarranty',
                },
            ],
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'newoptions',
            icon: iconPolizas,
            label: 'Operaciones',
            to: '/app/calculator',
            subs: [
                {
                    id: 'reprocess',
                    icon: iconPolizas,
                    label: 'Reprocesar desembolso',
                    to: '/app/ReprocessDisbursements',
                },
            ],
        },

        {
            id: 'cartera',
            icon: iconReportsDefault,
            label: 'Cartera',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Cargue Cartera',
                    to: '/app/collection/CollectionForm',
                },
                {
                    id: 'par1&par30-collection',
                    icon: iconReportsDefault,
                    label: 'Par1 & Par30',
                    to: '/app/collection/per1AndPer30',
                },
                {
                    id: 'par1&par30C-collection',
                    icon: iconReportsDefault,
                    label: 'Comparativo Cartera',
                    to: '/app/collection/per1AndPer30Comparative',
                },
            ],
        },

        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
                {
                    icon: iconClient,
                    label: 'Terceros',
                    to: '/app/reports/reportThirds',
                },
                {
                    id: 'mora-collection',
                    icon: iconReportsDefault,
                    label: 'Mora',
                    to: '/app/collection/lista',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Recaudos Pasarelas',
                    to: '/app/reportGatewayPayment',
                },
            ],
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconCalculator,
                    label: 'Simulador de Créditos',
                    to: '/app/calculator',
                },
                {
                    icon: iconCalculator,
                    label: 'Calculadora R&R',
                    to: '/app/reports/calculatorRefinancing',
                },
            ],
        },

        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    id: 'gyg',
                    icon: iconParametersGyg,
                    label: 'G&G',
                    to: '/app/gyg/parameterGyg',
                },
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Calculadora',
                    to: '/app/reports/calculatorParams',
                },
            ],
        },
        // {
        //     id: 'documentos',
        //     icon: iconDocs,
        //     label: 'Documentos',
        //     to: '/app/calculator',
        //     subs: [
        //         {
        //             id: 'certificados',
        //             icon: iconCertificate,
        //             label: 'Certificados',
        //             to: '/app/reports/peaceAndSafe',
        //             subs: [
        //                 {
        //                     id: 'fng-reports',
        //                     icon: iconCertificate,
        //                     label: 'Registrar',
        //                     to: '/app/reports/peaceAndSafe',
        //                 },
        //                 {
        //                     id: 'fng-reports',
        //                     icon: iconCertificate,
        //                     label: 'Consultar',
        //                     to: '/app/reports/checkCertificates',
        //                 },
        //             ],
        //         },
        //     ],
        // },
    ],
};
export default data;
